module.exports = __webpack_public_path__ + "static/img/person_2.bd91f28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/person_2.png
// module id = 0pwo
// module chunks = 1